import Axios, { AxiosInstance } from 'axios'

let axios: AxiosInstance

export const useAxios = () => {
  const config = useRuntimeConfig()

  const { KEYSTONE_API_URL = 'http://localhost:3001' } = config

  if (!axios) axios = Axios.create({ baseURL: KEYSTONE_API_URL })
  return axios
}
